/* PCKEY GROUP — MS VALUE ENGINEERING interactions */
(function(){
  'use strict';
  function ready(fn){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();}
  function money(cents){
    try{return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format((Number(cents)||0)/100);}catch(e){return 'R$ '+(((Number(cents)||0)/100).toFixed(2)).replace('.',',');}
  }
  ready(function(){
    document.querySelectorAll('[data-pckey-gallery]').forEach(function(gallery){
      var main=gallery.querySelector('[data-pckey-main-image]');
      gallery.querySelectorAll('[data-pckey-thumb]').forEach(function(btn){
        btn.addEventListener('click',function(){
          if(!main)return;
          gallery.querySelectorAll('[data-pckey-thumb]').forEach(function(b){b.classList.remove('is-active');});
          btn.classList.add('is-active');
          main.src=btn.getAttribute('data-image')||main.src;
          main.removeAttribute('srcset');
          main.alt=btn.getAttribute('data-alt')||main.alt;
        });
      });
    });

    document.querySelectorAll('[data-pckey-product-form]').forEach(function(root){
      var json=root.querySelector('[data-pckey-product-json]');
      var variants=[];
      try{variants=JSON.parse(json ? json.textContent : '[]')||[];}catch(e){variants=[];}
      var selects=Array.prototype.slice.call(root.querySelectorAll('[data-pckey-option-select]'));
      var idInput=root.querySelector('[data-pckey-variant-id]');
      var submit=root.querySelector('[data-pckey-submit]');
      var price=root.querySelector('[data-pckey-price]');
      var mobilePrice=document.querySelector('[data-pckey-mobile-price]');
      function selectedOptions(){return selects.map(function(s){return s.value;});}
      function findVariant(){
        if(!variants.length)return null;
        if(!selects.length)return variants[0];
        var chosen=selectedOptions();
        return variants.find(function(v){return chosen.every(function(value,index){return String(v.options[index])===String(value);});}) || null;
      }
      function update(){
        var variant=findVariant();
        if(idInput && variant)idInput.value=variant.id;
        if(submit){
          var available=!!(variant && variant.available);
          submit.disabled=!available;
          submit.textContent=available?'Comprar agora':'Indisponível';
        }
        if(variant && price){
          var priceNode=price.querySelector('.price,.eq-price,.price-item') || price;
          if(priceNode)priceNode.textContent=money(variant.price);
        }
        if(variant && mobilePrice)mobilePrice.textContent=money(variant.price);
      }
      selects.forEach(function(select){select.addEventListener('change',update);});
      update();
    });

    document.querySelectorAll('[data-pckey-qty-control]').forEach(function(control){
      var input=control.querySelector('input[type="number"]');
      var minus=control.querySelector('[data-pckey-qty-minus]');
      var plus=control.querySelector('[data-pckey-qty-plus]');
      function setValue(next){
        if(!input)return;
        var min=parseInt(input.getAttribute('min')||'1',10)||1;
        input.value=String(Math.max(min,next));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      if(minus)minus.addEventListener('click',function(){setValue((parseInt(input.value||'1',10)||1)-1);});
      if(plus)plus.addEventListener('click',function(){setValue((parseInt(input.value||'1',10)||1)+1);});
    });

    document.querySelectorAll('[data-pckey-sort-select]').forEach(function(select){
      select.addEventListener('change',function(){var form=select.closest('form'); if(form)form.submit();});
    });

    document.querySelectorAll('[data-pckey-scroll-buy]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var target=document.querySelector('.pckey-msv-buybox');
        if(target)target.scrollIntoView({behavior:'smooth',block:'center'});
      });
    });

    document.querySelectorAll('[data-pckey-card]').forEach(function(card){
      card.addEventListener('pointermove',function(event){
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        var rect=card.getBoundingClientRect();
        card.style.setProperty('--mx',((event.clientX-rect.left)/rect.width*100).toFixed(1)+'%');
        card.style.setProperty('--my',((event.clientY-rect.top)/rect.height*100).toFixed(1)+'%');
      });
    });
  });
})();
